import { HubFeature } from '@ats/api/cm';
import { LocDefs } from '@cm/core/localization';

export type CPCreqHistoryEnrollmentSharedLocNames = 'CPCReqHistoryEnrollmentContentNoExpiration';

export const creqEnrollmentSharedLocs: LocDefs<CPCreqHistoryEnrollmentSharedLocNames> = {
	CPCReqHistoryEnrollmentContentNoExpiration: {
		defaultValue: 'No Expiration',
		description: 'Content text for: No Expiration.',
		displayPath: 'History|Enrollment|No Expiration',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: true,
		legacyName: 'OtherRequirement/History.Enrollment.Content.NoExpiration',
	},
};
